import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useCart } from './CartContext';
import './rice.css';

const products = [
  { name: 'Kadai with Lid', image: '/images/claypots/kadai.webp', link: '/clay/kadaiwithlid' },
  { name: 'Paniyara Kal', image: '/images/claypots/paniyarakal.webp', link: '/clay/paniyarakal' },
  { name: 'Dosa Kal', image: '/images/claypots/dosa.webp', link: '/clay/dosakal' },
  { name: 'Thulasi Pot', image: '/images/claypots/thulasi.webp', link: '/clay/thulasipot' },
  { name: 'Frying Kadai', image: '/images/claypots/fry.webp', link: '/clay/fryingkadai' },
  { name: 'Tea Cup', image: '/images/claypots/tea.webp', link: '/clay/teacup' },
  { name: 'Water Pot', image: '/images/claypots/waterpot.webp', link: '/clay/waterpot' },
  { name: 'Tumbler', image: '/images/claypots/tumbler.webp', link: '/clay/tumbler' },
  { name: 'Elephant', image: '/images/claypots/elephantpot.webp', link: '/clay/elephant' },
  { name: 'Horse', image: '/images/claypots/horse.webp', link: '/clay/horse' },
  { name: 'Pongal Pot', image: '/images/claypots/pongal.png', link: '/clay/pongalpot' },
  { name: 'Briyani Pot', image: '/images/claypots/briyani.png', link: '/clay/briyanipot' },
  { name: 'Lamp Pot', image: '/images/claypots/lamp.webp', link: '/clay/lamppot' },
  { name: '2 ltr Pot', image: '/images/claypots/pot.webp', link: '/clay/pot2ltr' },
  { name: 'Water Bottle', image: '/images/claypots/water.webp', link: '/clay/waterbottle' }
];

const Oil = () => {
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [quantities, setQuantities] = useState({});

  const handleKnowMore = (link) => {
    navigate(link);
  };

  const goToProducts = () => {
    navigate('/products');
  };

  const incrementQty = (index) => {
    const currentQty = quantities[index] || 0;
    setQuantities({
      ...quantities,
      [index]: currentQty + 1,
    });
  };

  const decrementQty = (index) => {
    const currentQty = quantities[index] || 0;
    if (currentQty > 0) {
      setQuantities({
        ...quantities,
        [index]: currentQty - 1,
      });
    }
  };

  const handleAddToCart = (product, index) => {
    const qtyCount = quantities[index];
    if (!qtyCount || qtyCount === 0) {
      toast.warn("Please select a quantity!", { position: "top-right" });
      return;
    }

    const item = {
      ...product,
      qtyType: 'default',
      qtyCount,
    };

    addToCart(item);
    toast.success(`${product.name} (${qtyCount}) added to cart`, {
      position: "top-right",
      autoClose: 2000,
    });
  };

  return (
    <section className="rice">
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <h1>Jeyam Clay Pots</h1>
      <div className='border'>
        <img src="/images/border.png" className='border-img' alt="decorative border" />
      </div>
      <button className='back-btn' onClick={goToProducts}>⟵ Back to Products</button>

      <div className="product-grid">
        {products.map((product, index) => (
          <div className="product-card" key={index}>
            <img src={product.image} alt={product.name} />
            <div className="product-name">{product.name}</div>

            {/* Quantity Controls */}
            <div className="qty-controls" style={{ margin: "10px 0" }}>
              <button onClick={() => decrementQty(index)}>-</button>
              <span style={{ margin: "0 10px" }}>{quantities[index] || 0}</span>
              <button onClick={() => incrementQty(index)}>+</button>
            </div>

            <div className="btn-group">
              <button className="know-more" onClick={() => handleKnowMore(product.link)}>
                Know More
              </button>
              <button className="add-cart" onClick={() => handleAddToCart(product, index)}>
                Add to Cart
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className='cart-button'>
        <Link to="/cart">
          <button className='cart-btn'>Go To Cart</button>
        </Link>
      </div>
      <Link to="/cart" className="floating-cart-btn" title="Go to Cart">
        Go to cart 🛒
      </Link>

      <ToastContainer />
    </section>
  );
};

export default Oil;
